import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { memo } from 'react'

const FaIcon = ({ ...restProps }) => {
  return <FontAwesomeIcon {...restProps} />
}

export default memo(FaIcon)
